A JSON scalar type for representing arbitrary JSON values.
